<div *ngIf="eligibilityService.isLoading" class="spinner-container">
    <img src="assets/avanti-logo.svg" alt="Avanti Finance logo" />
    <div>Connecting to Avanti Finance...</div>
    <div class="loading-container">
        <div class="loading">
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
        </div>
    </div>
</div>

<ng-container *ngIf="!eligibilityService.isLoading">
    <section class="eligibility-intro">
        <div class="intro-inner">
            <div class="header">
                <div class="dealer-logo">
                    <div
                        *ngIf="eligibilityService.applicationConfigResponse.dealershipLogo && eligibilityService.applicationConfigResponse.dealershipLogo != ''">
                        <img [src]="eligibilityService.applicationConfigResponse.dealershipLogo" alt="Logo" />
                    </div>
                </div>

                <div class="ctas show-for-large">
                    <button mat-flat-button class="light-btn" (click)="applyNow()">Apply now</button>
                    <button mat-flat-button class="dark-btn" (click)="openEnquiryForm()">Get in touch</button>
                </div>
            </div>
            <div class="header-content">
                <div class="text">
                    <h1>Check your eligibility</h1>
                    <p>
                        We work with Avanti Finance to offer vehicle finance to our customers. Answer a few quick
                        questions below and they'll give you an indication of whether they may be able to help.                      
                    </p>
                    <p>
                        If Avanti Finance turns out to not be the right fit for you, we can usually offer other finance options - just ask. 
                    </p>
                    <p class="mat-body-medium section-title">
                        <span class="section-subtitle">Note: This pre-eligibility assessment is indicative only and does not constitute a credit approval or binding offer of finance. Lending criteria, terms, conditions, and fees apply.</span></p>
                </div>
                <div class="intro-image">
                    <img src="assets/eligibility-pic.svg" alt="Illustration of a person buying a car" />
                </div>
            </div>
        </div>
    </section>

    <app-eligibility-view></app-eligibility-view>

    <section class="eligibility-outro">
        <p>This tool is provided by Avanti Finance for indicative purposes only. It does not constitute financial
            advice. If
            you have questions about your eligibility please <button class="underline-link"
                (click)="openEnquiryForm()">contact us</button> directly.
        </p>
        <div class="ctas hide-for-large">
            <button mat-flat-button class="light-btn" (click)="applyNow()">Apply now</button>
            <button mat-flat-button class="dark-btn" (click)="openEnquiryForm()">Get in touch</button>
        </div>
        <div class="powered-by">
            Powered by <img src="assets/avanti-logo.svg" alt="Avanti Finance" />
        </div>
    </section>
</ng-container>